import { jsPDF } from 'jspdf';
import { fmtEuro } from './devisCalc';

const NAVY = [30, 58, 95];

export const genererPdf = (recap, annee) => {
  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 18;
  const contentW = pageW - margin * 2;
  let y = 0;

  const ensure = (h) => { if (y + h > 278) { doc.addPage(); y = 20; } };
  const text = (t, size, style, color, align) => {
    doc.setFontSize(size); doc.setFont('helvetica', style || 'normal'); doc.setTextColor(...(color || [0, 0, 0]));
    const lines = doc.splitTextToSize(t, contentW);
    ensure(lines.length * size * 0.5);
    doc.text(lines, align === 'center' ? pageW / 2 : margin, y, { align: align || 'left' });
    y += lines.length * size * 0.45 + 2;
  };
  const row = (label, montant, opts = {}) => {
    doc.setFontSize(opts.size || 10); doc.setFont('helvetica', opts.bold ? 'bold' : (opts.italic ? 'italic' : 'normal'));
    const lines = doc.splitTextToSize(label, contentW - 40);
    ensure(lines.length * 5 + 3);
    if (opts.fill) { doc.setFillColor(...opts.fill); doc.rect(margin, y - 4.5, contentW, lines.length * 5 + 2.5, 'F'); }
    doc.setTextColor(...(opts.color || [40, 40, 40]));
    doc.text(lines, margin + 2, y);
    if (montant !== null && montant !== undefined) doc.text(fmtEuro(montant), pageW - margin - 2, y, { align: 'right' });
    y += lines.length * 5 + 1.5;
  };

  // Bandeau
  doc.setFillColor(...NAVY); doc.rect(0, 0, pageW, 30, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(18);
  doc.text('HÔTEL OASIS PARK', pageW / 2, 13, { align: 'center' });
  doc.setFontSize(11); doc.text(`VOTRE DEVIS — LLORET DEL MAR ${annee}`, pageW / 2, 22, { align: 'center' });
  y = 40;
  text(`${recap.sejour.titre} — du ${recap.sejour.dates} (${recap.sejour.nuits} nuits)`, 11, 'bold', NAVY);
  if (recap.depart) text(`Point de départ du car : ${recap.depart}`, 10, 'normal', [80, 80, 80]);
  y += 3;

  // En-tête tableau
  row('Désignation', null, { bold: true, fill: [238, 243, 248], color: NAVY });
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...NAVY); doc.text('Montant', pageW - margin - 2, y - 6.5, { align: 'right' });

  recap.chambres.forEach((c) => {
    c.lignes.forEach((l) => row(l.label, l.montant));
    row(c.literie, null, { italic: true, size: 9, color: [100, 100, 100] });
    row(`Sous-total chambre ${c.num}`, c.soustotal, { bold: true, fill: [238, 243, 248], color: NAVY });
    y += 1;
  });
  recap.transport.forEach((l) => row(l.label, l.montant));
  recap.extras.forEach((l) => row(l.label, l.montant));
  y += 3;

  ensure(18);
  doc.setFillColor(205, 239, 210); doc.roundedRect(margin, y - 5, contentW, 14, 2, 2, 'F');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(11, 93, 30);
  doc.text(`TOTAL GÉNÉRAL À PAYER (${recap.nb} voyageur${recap.nb > 1 ? 's' : ''})`, margin + 3, y + 4);
  doc.setFontSize(15); doc.text(fmtEuro(recap.total), pageW - margin - 3, y + 4.5, { align: 'right' });
  y += 20;

  text("Le grand lit est une préférence, non une garantie : pour les couples, la chambre peut être aménagée avec deux lits simples rapprochés, selon les disponibilités de l'hôtel. La vue piscine est une option garantie avec supplément.", 8.5, 'italic', [90, 90, 90]);
  y += 2;
  text("Séjour en pension complète à l'Hôtel Oasis Park (Lloret de Mar) : chambre avec balcon, piscines, animations en journée et spectacles en soirée, plage et centre-ville à pied.", 9, 'normal', [60, 60, 60]);
  y += 2;
  text("Devis indicatif : le montant définitif est confirmé lors de l'inscription en ligne sur le site de l'association.", 8.5, 'italic', [120, 120, 120]);
  text('Rhône Alpes Amitié Voyages — SIRET 50511550100015 — rhoneamitie@gmail.com', 8, 'normal', [120, 120, 120]);

  doc.save(`devis-oasis-park-${annee}-${new Date().toISOString().slice(0, 10)}.pdf`);
};
